import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "./api/client";
import { useCurrentUser } from "./currentUserContext";

export default function TradeHistoryView() {
  const { selectedUserId, selectedUser } = useCurrentUser();
  const [completedCount, setCompletedCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isDisposed = false;

    async function loadTradeHistory() {
      try {
        setLoading(true);
        const response = await apiFetch("/api/trades/completed", { userId: selectedUserId });
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(data.error || "Could not load trade history");
        }

        if (!isDisposed) {
          setCompletedCount(Number(data?.summary?.completedCount) || 0);
          setError(null);
        }
      } catch (err) {
        if (!isDisposed) {
          console.error("Trade history load error:", err);
          setError(err.message || "Could not load trade history");
        }
      } finally {
        if (!isDisposed) {
          setLoading(false);
        }
      }
    }

    loadTradeHistory();

    return () => {
      isDisposed = true;
    };
  }, [selectedUserId]);

  return (
    <div className="account-shell">
      <div className="account-settings-page">
        <div className="account-breadcrumb">
          <Link to="/account">My Account</Link>
          <span>/</span>
          <span>Trade History</span>
        </div>

        <div className="account-settings-panel__header">
          <div>
            <h1 className="account-title">Trade History</h1>
            <p className="account-copy">
              Review the completed trade total for {selectedUser?.label || "this user"}.
            </p>
          </div>
        </div>

        {error ? <div className="account-error">{error}</div> : null}

        {loading ? (
          <div className="account-loading">Loading trade history...</div>
        ) : (
          <div className="account-setting-grid account-setting-grid--stacked-mobile">
            <section className="account-setting-card">
              <div className="account-history-stat">
                <div className="account-history-stat__label">Total completed trades</div>
                <div className="account-setting-card__value">{completedCount}</div>
                <p className="account-setting-card__copy">
                  This is the total number of trades that have been fully completed for this account.
                </p>
              </div>
            </section>
          </div>
        )}
      </div>
    </div>
  );
}